'use client';
import React, { useEffect } from 'react';

import { icons } from '@/Icons';
import Image from 'next/image';

import { useUser } from '@/store';
import { OnboardingStepsEnum, useOnboardingStoreActions } from './store';

import dynamic from 'next/dynamic';

const Steps = dynamic(() => import('./components/Steps/Steps'), {
	ssr: false,
});
const ProgressBar = dynamic(
	() => import('./components/ProgressBar/ProgressBar'),
	{
		ssr: false,
	}
);

const Onboarding = () => {
	const user = useUser();
	const { setOnboardingStep } = useOnboardingStoreActions();

	useEffect(() => {
		if (user) {
			if (user?.currentOnboardingStep) {
				setOnboardingStep(user?.currentOnboardingStep);
			}
		}
	}, [user]);

	if (!user) {
		return null;
	}
	if (
		user?.currentOnboardingStep === OnboardingStepsEnum.ONBOARDING_SKIPPED ||
		user?.currentOnboardingStep === OnboardingStepsEnum.ONBOARDING_COMPLETED
	) {
		return null;
	}

	return (
		<div
			className={`  fixed z-[500] grid lg:grid-cols-2 md:top-0 left-0 overflow-hidden h-screen bottom-0 w-screen overflow-x-hidden overflow-y-scroll bg-[rgba(0,0,0,0.4)] backdrop-blur-[10px]`}
		>
			<section
				className=" bg-midnight-blue flex flex-col justify-center items-center gap-4 px-5 h-screen max-h-[85%] md:max-h-screen
			bottom-0 w-screen md:w-auto absolute md:relative popup"
			>
				<div className="absolute top-5 left-4 hidden md:block">
					<icons.mainlogo additionalText />
				</div>
				<div
					className=" w-full max-w-[430px] grid h-full  py-14 gap-5"
					style={{
						gridTemplateRows: '1fr min-content',
					}}
				>
					<Steps />
					<ProgressBar />
				</div>
			</section>
			<section className=" bg-teal-blue relative hidden lg:block">
				<Image
					src="/img/onboarding/onboarding_promo.webp"
					alt="onboarding"
					fill
					className="w-full h-full object-cover object-center"
				/>
			</section>
		</div>
	);
};

export default Onboarding;

{
	/* <ModalWrapper onClose={() => {}}> */
}
{
	/* </ModalWrapper> */
}
